import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.periodsForObjectives],
        config: {
            headerName: getLocalizedString("periodCode"),
            field: 'code',
            filter: "agTextColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.periodsForObjectives],
        config: {
            headerName: getLocalizedString("periodName"),
            field: 'name',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.periodsForObjectives],
        config: {
            headerName: getLocalizedString("dateFrom"),
            field: "initialDate",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.periodsForObjectives],
        config: {
            headerName: getLocalizedString("dateEnd"),
            field: "endDate",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.periodsForObjectives],
        config: {
            headerName: getLocalizedString("periodStatus"),
            field: 'statusString',
            filter: "agSetColumnFilter",
        }
    },
]